/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import PaginatedListState from 'flarum/common/states/PaginatedListState';

export default class AchievementLevelsState extends PaginatedListState {
	get type() {
		return 'achievement_levels';
	}

	async loadAll() {
		await this.refresh();

		while (this.hasNext()) {
			await this.loadNext();
		}
	}
}
